export type MasterDataSearchBySection =
  | "purchasers"
  | "distribution-centers"
  | "products"
  | "product-categories"
  | "product-uom"
  | "deduction-categories"
  | "types-subtypes"
  | "reason-code"
  | "product-prices"
  | "retailers";

/** Static searchable field labels shown in the Search by Popover (informational only). */
export const MASTER_DATA_SEARCH_BY_FIELDS: Record<
  MasterDataSearchBySection,
  readonly string[]
> = {
  purchasers: ["Purchaser Name", "Purchaser Key", "Search Keywords"],
  "distribution-centers": [
    "DC Code",
    "DC Name",
    "Purchaser Name",
    "Purchaser Key",
  ],
  products: [
    "Product Name",
    "Product Key",
    "UPC",
    "GL Item #",
    "Category Name",
  ],
  "product-categories": [
    "Category Name",
    "Category Key",
    "Category Description",
  ],
  "product-uom": ["UOM Name", "UOM Code", "UOM Description"],
  "deduction-categories": ["Category Name", "Category Key"],
  "types-subtypes": [
    "Name",
    "Deduction Type Key",
    "Sub-type Name",
    "Sub-type Key",
  ],
  "reason-code": [
    "Purchaser",
    "Reason Code",
    "Reason Code Key",
    "Deduction Type",
  ],
  "product-prices": [
    "Product Name",
    "Product Key",
    "UPC",
    "Category Name",
  ],
  retailers: ["Retailer Name", "Retailer Key"],
};
